import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const Features = (props) => {
  const { features } = props;

  return (
    <StyledSection>
      <Title>The features you need</Title>
      <Wrapper>
        {features.map((feature) => {
          const Icon = feature.icon;
          return (
            <Feature key={feature.title}>
              <FeatureIcon>
                <Icon />
              </FeatureIcon>
              <FeatureContent>
                <FeatureTitle>{feature.title}</FeatureTitle>
                <Content>{feature.content}</Content>
              </FeatureContent>
            </Feature>
          );
        })}
      </Wrapper>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  margin-bottom: 200px;
`;

const Title = styled.h2`
  font-size: var(--heading-size-base);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-base);
  color: var(--blue-dark);
  margin-bottom: 60px;
`;

const Wrapper = styled.ul`
  display: flex;
  align-items: start;
  flex-wrap: wrap;
`;

const Feature = styled.li`
  width: 100%;
  margin-bottom: 90px;
  display: flex;
  align-items: start;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
        width: 50%;
    }
  `}
  ${({ theme }) => `
    @media ${theme.xLargeUp} {
        width: ${100 / 3}%;
    }
  `}
`;

const FeatureContent = styled.div`
  flex: auto;
  padding-right: 40px;
`;

const FeatureIcon = styled.div`
  padding-right: 22px;
`;

const FeatureTitle = styled.h3`
  font-size: var(--font-size-lg);

  color: var(--blue-dark);

  font-weight: var(--font-weight-bold);
  margin-bottom: 10px;
`;

const Content = styled.p``;

export default Features;
